// module imports
import { toast, ToastContent, ToastOptions, UpdateOptions } from 'react-toastify';

// Centralized default options to keep a consistent look & behavior
const defaultOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

export function showSuccess(message: ToastContent, options?: ToastOptions) {
  return toast.success(message, { ...defaultOptions, ...options });
}

export function showError(message: ToastContent, options?: ToastOptions) {
  return toast.error(message, { ...defaultOptions, ...options });
}

export function showInfo(message: ToastContent, options?: ToastOptions) {
  return toast.info(message, { ...defaultOptions, ...options });
}

export function showWarning(message: ToastContent, options?: ToastOptions) {
  return toast.warn(message, { ...defaultOptions, ...options });
}

// Handy helper for API errors (Axios or generic)
export function showApiError(error: unknown, fallback = 'Something went wrong', options?: ToastOptions) {
  const message = (typeof error === 'object' && error !== null && 'response' in error && (error as any).response?.data?.error) || (typeof error === 'object' && error !== null && 'message' in error && (error as any).message) || fallback;
  return showError(String(message), options);
}

// Promise-style toasts
export function showPromise<T>(promise: Promise<T>, msgs: { pending: ToastContent; success: ToastContent | ((data: T) => ToastContent); error: ToastContent | ((err: any) => ToastContent) }, options?: ToastOptions) {
  return toast.promise(promise, msgs as any, { ...defaultOptions, ...options });
}

// Expose low-level helpers for updating/dismissing if needed
export const updateToast = (id: string | number, options: UpdateOptions) => toast.update(id, options);
export const dismissToast = (id?: string | number) => toast.dismiss(id);

export type { ToastOptions };
